import Text from '../../../../shared/Text'
import { IconSelling } from '../../../../shared/Icon'

import styles from './ListingAgent.module.scss'

export interface ListingAgentProps {
  agent: string
}

export const ListingAgent = ({ agent }: ListingAgentProps) => {
  return (
    <div className={styles.agentWrapper}>
      <IconSelling className={styles.icon} />
      <Text variant='neutralCool' variantCount='600' size='xs'>
        {agent}
      </Text>
    </div>
  )
}
